module.exports = __webpack_public_path__ + "img/03ecf08.png";